import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Impact", to: "/about_us" },
  { label: "Events", to: "/calendar" },
  { label: "Gallery", to: "/media" },
  { label: "Get Involved", to: "/partnerships" },
];

export const TAG_META = {
  "Cultural Festival": "#0d4f6e",
  "Community": "#c9a84c",
  "Arts": "#0f766e",
  "Celebration": "#7c3aed",
  "Panel": "#be185d",
  "Literacy": "#0e7490",
};

export const LINKS = {
  donate: "https://givebutter.com/Ethosfoundation",
  wishlist: "https://bookshop.org/wishlists/b52884d852dcbd0c3cc77374f12c227e5a829cc9",
  website: "https://ethosfoundation.net/",
  email: "info@ethosfoundation.net",
};
